import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { collections } from '../../data/collections';
import { productsForCollection } from '../../utils/products';
export function ShopTiles() {
  const tiles = collections.filter(c => c.image);
  return <section className="mx-auto max-w-7xl py-10 lg:px-8 lg:py-14" aria-labelledby="shop-tiles" data-id="element-116" data-mp="2wjac9ntt0wr7">
      <h2 id="shop-tiles" className="sr-only" data-id="element-117" data-mp="1zt0088zryn7w">Shop direct</h2>
      <ul className="no-scrollbar flex snap-x snap-mandatory gap-3 overflow-x-auto px-5 lg:grid lg:grid-cols-5 lg:gap-5 lg:overflow-visible lg:px-0" data-id="element-118" data-mp="1zukxw7hdym9z">
        {tiles.map(c => <li key={c.slug} className="w-[42%] shrink-0 snap-start sm:w-[30%] lg:w-auto" data-id="element-119" data-mp="28rlie31c4085">
            <Link to={`/collectie/${c.slug}`} className="group block" data-id="element-120" data-mp="2dt2ihwbzvino">
              <div className="overflow-hidden rounded-2xl bg-surface" data-id="element-121" data-mp="3k94p45e4ilbg">
                <img src={c.image} alt="" className="aspect-[4/5] w-full object-cover transition-transform duration-300 ease-out group-hover:scale-[1.03]" data-id="element-122" data-mp="3p7fxscsomps3" />
              </div>
              <div className="mt-3 flex items-center justify-between" data-id="element-123" data-mp="a40ka2h017ck">
                <div data-id="element-124" data-mp="5332hqzwifbl">
                  <p className="text-base font-semibold tracking-tight text-ink" data-id="element-125" data-mp="52jhu2iv9ctv">{c.title}</p>
                  <p className="text-sm text-muted" data-id="element-126" data-mp="3gfipu9tkpl">{productsForCollection(c).length} producten</p>
                </div>
                <span className="grid h-9 w-9 place-items-center rounded-full border border-line transition-colors duration-150 group-hover:border-ink group-hover:bg-ink group-hover:text-canvas" data-id="element-127" data-mp="3rcdqgs9n9d2b">
                  <ArrowRightIcon className="h-4 w-4" data-id="element-128" data-mp="3ij0q55993967" />
                </span>
              </div>
            </Link>
          </li>)}
      </ul>
    </section>;
}